export default [
  {
    name: 'count',
    method: 'post',
    desc: '图表统计',
    path: '/obt/statistical/count',
    params: {
      queryDate: ''
    }
  },
  {
    name: 'countTkInfo',
    method: 'post',
    desc: '机票订单统计',
    path: '/obt/statistical/countTkInfo',
    params: {
      startDate: '',
      endDate: ''
    }
  },
  {
    name: 'countTkList',
    method: 'get',
    desc: '机票订单统计列表',
    path: '/obt/statistical/countTkList',
    params: {
      pageNum: 1,
      count: 10,
      startDate: '',
      endDate: ''
    }
  }
]
